import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';
import { actionAddGlobalError } from 'react-redux-app/lib/modules/globalError/actions';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionLoadSiteRequest } from '../../actions/loadSite';
import { actionSetCurrentSiteId } from '../../actions';

import { getCurrentSiteId } from '../../selectors';
import { getLoadSiteError } from '../../selectors/errors';
import { getSiteName } from '../../selectors/site';
import { getSitesUrl } from '../../../app/utils/siteUrls';
import { getCurrentLang } from 'react-redux-app/lib/modules/i18n/selectors';

import { LOAD_SITE_ERROR__NOT_FOUND } from '../../constants/errors';


export default ({ getState, dispatch }) => (
  function loadSiteHandler(nextState, successCallback, errorCallback) {
    if (getCurrentSiteId(getState())) {
      successCallback();
      return;
    }

    const { siteId } = nextState.params;

    dispatch(
      actionLoadSiteRequest(siteId)
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadSiteError(getState());
        if (error) {
          if (maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)) {
            return;
          }

          if (error.globalErrors[0].code === LOAD_SITE_ERROR__NOT_FOUND) {
            dispatch(actionAddGlobalError({
              text: { id: 'error.not-found' },
              header: { id: 'header.site' },
            }));

            errorCallback(getSitesUrl(getCurrentLang(getState())));
            return;
          }
        }

        if (getSiteName(getState(), siteId)) {
          dispatch(actionSetCurrentSiteId(siteId));
          successCallback();
          return;
        }

        console.consoleError(
          `loadSiteHandler. Unable to load site. Make redirect to ${INTERNAL_ERROR_URI}`
        );
        errorCallback(INTERNAL_ERROR_URI);
      }
    ).catch(error => {
      console.consoleError('loadSiteHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
